module.exports = __webpack_public_path__ + "img/documentos.8798abc4.jpg";